import './interfaces-ecommerce-v1-discounts-provider.public.js';
import { createServicePluginModule } from '@wix/sdk-runtime/service-plugin-modules';
import { provideHandlers as publicProvideHandlers } from './interfaces-ecommerce-v1-discounts-provider.public.js';

export { publicProvideHandlers };

export const provideHandlers: ReturnType<
  typeof createServicePluginModule<typeof publicProvideHandlers>
> = createServicePluginModule(publicProvideHandlers);
